import { Reviews as ReviewsModule } from "../modules/Reviews/Reviews";

const Reviews = () => {
  return <ReviewsModule />;
};

export default Reviews;
